<template>
    <div class="event-label" :class="className">
        {{ title }}
    </div>
</template>

<script>
export default {
    name: 'EventLabel',
    props: {
        title: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'audience',
        },
        hasBorder: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        className() {
            return {
                [`${this.type}`]: Boolean(this.type),
                'with-border': this.hasBorder,
            };
        },
    },
};
</script>

<style lang="postcss" scoped>
.event-label {
    @mixin note;
    margin-inline-end: 3px;
    margin-inline-start: 3px;
    margin-bottom: 8px;
    height: 16px;
    padding: 0 8px;
    border-radius: 4px;
    color: var(--av-inversed-primary);
    white-space: nowrap;
    text-transform: uppercase;

    &.with-border {
        line-height: 14px;
        border: 1px solid var(--av-fixed-info-dark);
    }

    &.event-organizer {
        background-color: var(--av-nav-primary);
        border-color: var(--av-fixed-info-dark);
    }

    &.target-audience {
        background-color: var(--av-button-action);
        border-color: var(--av-button-action-hover);
    }

    &.event-category {
        background-color: var(--av-solid-brand-secondary-light);
        border-color: var(--av-nav-secondary);
        color: var(--av-nav-primary);
    }

    &.event-type {
        background-color: var(--av-nav-secondary);
        border-color: var(--el-primary-active);
    }
}
</style>
